import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import { BCMSStateManagerCRUD, useBCMSContext, BCMSRecord, BCMSDate } from "bcms-react";
import Classes, { Account } from "model";

export default function CaptureLoanTransferDescriptionEntered(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], Account.initByID("0"))
        .update([ "transfer", "to" ], Account.initByType("3"))
        .update([ "transfer", "paymentOption" ], "Payment Due")
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "duration" ], "No End Date")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .update([ "transfer", "description" ], "Sample")
        .submit();

    const ui = getDefaultPageUI(data.transfer, globalController);

    return <TransfersPage data={ data } ui={ ui } />
}